// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/sass/layout.scss
// module id = ./src/sass/layout.scss
// module chunks = 4